const Container = ({ x, y, children }) => {
  const style = {
    padding: `${y} ${x}`,
    width: '100%',
  };

  return (
    <div className="container" style={style}>
      {children}
    </div>
  );
};

Container.defaultProps = {
  x: '2rem',
  y: '2rem',
};

export default Container;
